import React from 'react';
import useAuth from 'core/hooks/useAuth';
import { Redirect, Route } from 'react-router-dom';
import { ROLE_ADMIN } from 'constants/types';

const RestrictedRoute = ({
  roles = [],
  features = [],
  restrictRoles = [],
  ...rest
}) => {
  const {
    isAuthenticated,
    tenantId,
    company,
    user = {},
    features: userFeatures = []
  } = useAuth();
  const userRoles = user?.role ? [user?.role] : user?.roles || [];

  const userHasRole = () => {
    return (
      roles.length === 0 ||
      roles.findIndex((c) => userRoles.includes(c) || c === '*') >= 0
    );
  };

  const userHasFeature = () => {
    return (
      features.length === 0 ||
      features.findIndex((c) => userFeatures.includes(c)) >= 0
    );
  };

  const redirectToDefaultUserRoute = () => {
    const role =
      restrictRoles.find((c) => userRoles.includes(c.name)) ||
      restrictRoles.find((c) => c.name === `*`);

    if (userRoles.includes(ROLE_ADMIN)) {
      return <Route {...rest} />;
    }

    if (role && role.defaultPath) {
      return (
        <Route {...rest} render={() => <Redirect to={role.defaultPath} />} />
      );
    }

    return <Route {...rest} render={() => <Redirect to="/" />} />;
  };

  if (!userRoles.includes(ROLE_ADMIN) && !tenantId) {
    return (
      <Route {...rest} render={() => <Redirect to="/accounts-chooser" />} />
    );
  }

  if (!isAuthenticated) {
    localStorage.removeItem('tenantId');
    return <Route {...rest} render={() => <Redirect to="/signin" />} />;
  }

  if (company && tenantId && (!userHasRole() || !userHasFeature())) {
    return redirectToDefaultUserRoute();
  }

  return <Route {...rest} />;
};

export default RestrictedRoute;
